<div class="d-flex row-cols-12">
    <div class="col-7">
        <h3 class="title">{{selectedOrganisationName}}</h3>
    </div>
    <ng-container *ngIf="user !== undefined && (user.isSystemAdmin || user.isWhitelabelAdmin)">
        <div class="col-5 pt-3">
            <button type="submit" id="changeOrganisation" translate="Button.ChangeOrganisation" class="btn btn-sm btn-secondary float-end me-4" (click)="openChangeOrganisationModal()"></button>
        </div>
    </ng-container>
</div>
<router-outlet></router-outlet>